var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_803_25164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_803_25164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5963 18V17H9.34225C8.30508 17 7.42142 16.6442 6.69125 15.9327C5.96125 15.2212 5.59625 14.3527 5.59625 13.327C5.59625 12.3013 5.96125 11.4359 6.69125 10.7307C7.42142 10.0256 8.30508 9.673 9.34225 9.673H17.0845L14.1192 12.6385L14.827 13.3463L19 9.173L14.827 5L14.1192 5.70775L17.0845 8.673H9.34225C8.03325 8.673 6.915 9.12433 5.9875 10.027C5.06 10.9295 4.59625 12.0295 4.59625 13.327C4.59625 14.6243 5.06 15.7275 5.9875 16.6365C6.915 17.5455 8.03325 18 9.34225 18H16.5963Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.33fd9be7ab5635ff377ffa29ac0cf6a2.svg";
export { ForwardRef as ReactComponent };